import usePageMeta from "utils/usePageMeta";
import Navbar from "./sections/Navbar";
import Hero from "./sections/Hero";
import Products from "./sections/Products";
import HowItWorks from "./sections/HowItWorks";
import WhoWeSupply from "./sections/WhoWeSupply";
import GlobalNetwork from "./sections/GlobalNetwork";
import CTA from "./sections/CTA";
import ContactForm from "./sections/ContactForm";

function SuppliesPage() {
  usePageMeta({
    title: "Spechs Supplies | Facilities & Hygiene Products Delivered in Ireland",
    description:
      "Professional facilities supplies for businesses across Ireland — cleaning chemicals, hygiene products, PPE, janitorial equipment, and washroom essentials delivered to your door.",
    canonical: "https://www.spechs.ie/supplies/",
  });

  return (
    <>
      <Navbar />
      <Hero />
      <Products />
      <HowItWorks />
      <WhoWeSupply />
      <GlobalNetwork />
      <CTA />
      <ContactForm />
    </>
  );
}

export default SuppliesPage;
